
    // this file was auto generated by python script
    import CheckCircle from './CheckCircle';
    export default CheckCircle;
    